// extracted by mini-css-extract-plugin
export var person = "styles-module--person--TuUOJ";
export var person_img = "styles-module--person_img--3Z_c_";
export var person_text = "styles-module--person_text--32ggl";
export var person_text_name = "styles-module--person_text_name--AxqRK";